/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicoProgramasModelDto } from '../../models/medico-programas-model-dto';

export interface MedicosControllerObtenerMedico$Params {

/**
 * UUID del médico a obtener
 */
  uuidMedico: string;
}

export function medicosControllerObtenerMedico(http: HttpClient, rootUrl: string, params: MedicosControllerObtenerMedico$Params, context?: HttpContext): Observable<StrictHttpResponse<MedicoProgramasModelDto>> {
  const rb = new RequestBuilder(rootUrl, medicosControllerObtenerMedico.PATH, 'get');
  if (params) {
    rb.path('uuidMedico', params.uuidMedico, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MedicoProgramasModelDto>;
    })
  );
}

medicosControllerObtenerMedico.PATH = '/api/medicos/obtener-medico/{uuidMedico}';
